type FnType = (...args: any[]) => any

/**
 * Creates a throttled function that only invokes func at most
 * once per every wait milliseconds
 * @param fn function do throttle
 * @param delay how long to wait
 * @returns executed function
 */
export function throttleFn(fn: FnType, delay: number): FnType {
  let lastCall = 0
  return function (...args) {
    const now = new Date().getTime()
    if (now - lastCall < delay) {
      return
    }
    lastCall = now
    return fn(...args)
  }
}
